import axios from 'axios';

export const authApi = {
  login: async (credentials) => {
    try {
      const response = await axios.post('/api/auth/login', credentials, {
        withCredentials: true, // This replaces credentials: 'include'
      });
      
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Authentication failed');
    }
  },

  logout: async () => {
    try {
      await axios.post('/api/logout', null, {
        withCredentials: true,
      });
      
      return true;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Logout failed');
    }
  },
}; 